import React, { Fragment, useContext, useEffect, useState } from "react";
import { LineChart } from "../components";
import useAxiosInterceptors from "../../hooks/httpConfig";
import { Link } from "react-router-dom";
import { ProgrammeContext, UserContext } from "../../contexts/UserContext";
import { computeAchatVenteTotals } from "../Startup/pages/Helpers";

export function DashboardStartup() {
  const apiInstance = useAxiosInterceptors();
  const [projet] = useContext(ProgrammeContext);
  const [user] = useContext(UserContext);

  // const [consultants, setConsultants] = useState([]);
  const [bienCount, setBienCount] = useState(0);
  const [startup, setStartup] = useState({});
  const [activite, setActivite] = useState({});
  const [devise, setDevise] = useState({});
  const [followups, setFollowups] = useState([]);
  const [operationsCount, setOperationsCount] = useState({ total: 0 });
  const [achatMontant, setAchatMontant] = useState(0);
  const [venteMontant, setVenteMontant] = useState(0);
  const [budgetAlloue, setBudgetAlloue] = useState(0);
  const [budgetRecu, setBudgetRecu] = useState(0);
  const [budgetDepense, setBudgetDepense] = useState(0);

  useEffect(() => {
    const programme = projet?.programme?._id;
    const entreprise = user?.entreprise?._id;
    if (programme && entreprise) {
      apiInstance
        .get(`/startup/${entreprise}/findDataPilote/${programme}`)
        .then(({ data }) => {
          // setConsultants(data.consultants);
          setBienCount(data.countBiens);
          setStartup(data.pilote);
          setActivite(data.activite);
          setDevise(data.devise);
          setOperationsCount(data.operations || { total: 0 });
          setBudgetAlloue(data.budgetAlloue || 0);
          setBudgetRecu(data.budgetRecu || 0);
          setBudgetDepense(data.budgetDepense || 0);
        });
    }
  }, [apiInstance, projet?.programme?._id, user?.entreprise?._id]);

  useEffect(() => {
    const entreprise = user?.entreprise?._id;
    if (entreprise) {
      apiInstance.get(`/startup/operations/${entreprise}`).then(({ data }) => {
        const { achat, vente } = computeAchatVenteTotals(data);
        setAchatMontant(achat);
        setVenteMontant(vente);
      });
    }
  }, [apiInstance, user?.entreprise?._id]);

  useEffect(() => {
    const programme = projet?.programme?._id;
    if (programme) {
      apiInstance.get(`/followup/programme/${programme}`).then(({ data }) => {
        setFollowups(data || []);
      });
    }
  }, [apiInstance, projet?.programme?._id]);

  const entrepriseId = user?.entreprise?._id;
  const followupsCreated = followups.filter(
    (f) => (f?.auteur?._id || f?.auteur) === entrepriseId,
  ).length;
  const followupsReceived = followups.filter(
    (f) =>
      Array.isArray(f?.destinataire) &&
      f.destinataire.some((d) => (d?._id || d) === entrepriseId),
  ).length;

  return (
    <Fragment>
      <div className="Content-Container">
        <div className="PageHeader">
          <div className="row">
            <div className="col-md-4">
              <h3 className="PageHeader-Title">Dashboard</h3>
            </div>
          </div>
        </div>

        <LineChart />

        <div className="StatsBox">
          <div className="row">
            {/* Entreprise */}
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Mon entreprise</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-building"></i>
                    </div>
                  </div>
                </div>
                <div className="m-4">
                  {startup?.nom && (
                    <div className="mb-2">
                      <strong>Nom :</strong> {startup.nom}
                    </div>
                  )}
                  {startup?.activite && (
                    <div className="mb-2">
                      <strong>Activité :</strong>{" "}
                      {startup.activite.replace("/", " / ")}
                    </div>
                  )}
                  {startup?.secteur && (
                    <div className="mb-2">
                      <strong>Secteur :</strong> {startup.secteur}
                    </div>
                  )}
                  {startup?.lieu && (
                    <div className="mb-2">
                      <strong>Lieu :</strong> {startup.lieu}
                    </div>
                  )}
                  {startup?.creation && (
                    <div className="mb-2">
                      <strong>Création :</strong>{" "}
                      {new Date(startup.creation).toLocaleDateString("fr-FR")}
                    </div>
                  )}
                  {startup?.team && Array.isArray(startup.team) && (
                    <div className="mb-2">
                      <strong>Équipe :</strong> {startup.team.length} membre
                      {startup.team.length > 1 ? "s" : ""}
                    </div>
                  )}
                  {bienCount > 0 && (
                    <div className="mb-2">
                      <strong>Biens :</strong> {bienCount}
                    </div>
                  )}
                  {startup?._id && (
                    <Link to={`/startup/${startup._id}`} className="Menu-Link">
                      Voir plus
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {/* Activités */}
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Mes activités</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-clipboard-alt"></i>
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <span>{activite.total ?? 0}</span>
                      <label>Total activités</label>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <span>{activite.Done ?? 0}</span>
                      <label>Présences</label>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <span>{activite.NotDone ?? 0}</span>
                      <label>Absences</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Budget */}
            <div className="col-md-3">
              <div className="Purple-BOX DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Budgets</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-wallet"></i>
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget alloué</label>
                      <span>{`${budgetAlloue.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    </div>
                  </div>
                  {/* <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget reçu</label>
                      <span>{`190000 ${devise?.symbole}`}</span>
                    </div>
                  </div> */}
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget reçu</label>
                      <span>{`${budgetRecu.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget dépensé</label>
                      <span>{`${budgetDepense.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Followups */}
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Mes followups</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-file-alt"></i>
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Créés</label>
                      <span>{followupsCreated}</span>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Reçus</label>
                      <span>{followupsReceived}</span>
                    </div>
                  </div>
                </div>
                <div className="m-4">
                  <Link to="/startup/follow-up" className="Menu-Link">
                    Voir plus
                  </Link>
                </div>
              </div>
            </div>

            {/* Mon consultant */}
            {/* <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Mon consultant</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-user-md"></i>
                    </div>
                  </div>
                </div>
                <div className="m-4">
                  {consultant ? (
                    <>
                      {consultant.nom && (
                        <div className="mb-2">
                          <strong>Nom :</strong> {consultant.nom}
                        </div>
                      )}
                      {consultant.activite && (
                        <div className="mb-2">
                          <strong>Activité :</strong> {consultant.activite}
                        </div>
                      )}
                      {consultant.secteur && (
                        <div className="mb-2">
                          <strong>Secteur :</strong> {consultant.secteur}
                        </div>
                      )}
                      {consultant.email && (
                        <div className="mb-2">
                          <strong>Email :</strong> {consultant.email}
                        </div>
                      )}
                      {consultant.telephone && (
                        <div className="mb-2">
                          <strong>Tél :</strong> {consultant.telephone}
                        </div>
                      )}
                      {consultant._id && (
                        <Link
                          to={`/startup/consultant/${consultant._id}`}
                          className="Menu-Link"
                        >
                          Voir plus
                        </Link>
                      )}
                    </>
                  ) : (
                    <p className="text-muted">Aucun consultant assigné</p>
                  )}
                </div>
                <div className="BOX-Footer"></div>
              </div>
            </div> */}
          </div>

          <div className="row mt-3">
            {/* Performances */}
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Performances</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-chart-line"></i>
                    </div>
                  </div>
                </div>
                <div className="m-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="mb-0">Achats</label>
                    <span>{`${achatMontant.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="mb-0">Ventes</label>
                    <span>{`${venteMontant.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="mb-0">Biens</label>
                    <span>{bienCount}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="mb-0">Opérations</label>
                    <span>{operationsCount.total}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
